<template>
  <div class="titleToolbar">
    <TemplateTitleToolbar v-if="!$route.subtitle"></TemplateTitleToolbar>
    <VideoTitleToolbar v-if="$route.subtitle"></VideoTitleToolbar>
  </div>
</template>

<script>
import TemplateTitleToolbar from "./templateTitleToolbar";
import VideoTitleToolbar from "./videoTitleToolbar";
export default {
  name: "titleToolbar",
  data() {
    return {};
  },
  props: {},
  components: {
    TemplateTitleToolbar,
    VideoTitleToolbar,
  },
  methods: {},
  watch: {},
  computed: {},
};
</script>

<style scoped lang='scss'>
.titleToolbar {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 0px solid black;
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/titleToolbar/titleToolbar.vue